import React from 'react';

const AddressForm = ({ editingAddress, handleCancel, register, handleSubmit, errors }) => (
    <form onSubmit={handleSubmit} className="account-form">
        <div className="account-field">
            <label className="account-field__label" htmlFor="account-city">
                Город
            </label>
            <input
                id="account-city"
                {...register('City', {
                    required: 'Не указан город',
                    pattern: {
                        value: /^[а-яА-ЯёЁ \-]+$/,
                        message: 'Город может содержать только буквы кириллицы',
                    },
                    minLength: { value: 2, message: 'Минимум 2 символа' },
                    maxLength: { value: 20, message: 'Максимум 20 символов' },
                })}
                defaultValue={editingAddress.City || ''}
                className="account-input"
            />
            {errors.City && <p className="account-error">{errors.City.message}</p>}
        </div>

        <div className="account-field">
            <label className="account-field__label" htmlFor="account-county">
                Область
            </label>
            <input
                id="account-county"
                {...register('County', {
                    pattern: {
                        value: /^[а-яА-ЯёЁ\- ]+$/,
                        message: 'Область может содержать только буквы кириллицы',
                    },
                })}
                defaultValue={editingAddress.County || ''}
                className="account-input"
            />
        </div>

        <div className="account-field">
            <label className="account-field__label" htmlFor="account-address">
                Адрес
            </label>
            <input
                id="account-address"
                {...register('AddressString', {
                    required: 'Не указан адрес',
                    pattern: {
                        value: /^[а-яА-ЯёЁ0-9 .,\-\/]+$/,
                        message: 'Адрес может содержать только кириллицу, цифры и допустимые символы',
                    },
                    minLength: { value: 2, message: 'Минимум 2 символа' },
                    maxLength: { value: 50, message: 'Максимум 50 символов' },
                })}
                defaultValue={editingAddress.AddressString || ''}
                className="account-input"
            />
            {errors.AddressString && <p className="account-error">{errors.AddressString.message}</p>}
        </div>

        <div className="account-form__grid">
            <div className="account-field">
                <label className="account-field__label" htmlFor="account-index">
                    Индекс
                </label>
                <input
                    id="account-index"
                    type="number"
                    {...register('Index', {
                        required: 'Не указан индекс',
                        pattern: {
                            value: /^\d{6}$/,
                            message: 'Индекс должен содержать 6 цифр',
                        },
                    })}
                    defaultValue={editingAddress.Index || ''}
                    className="account-input"
                />
                {errors.Index && <p className="account-error">{errors.Index.message}</p>}
            </div>

            <div className="account-field">
                <label className="account-field__label" htmlFor="account-phone">
                    Телефон
                </label>
                <input
                    id="account-phone"
                    {...register('Phone', {
                        required: 'Укажите телефон',
                        pattern: {
                            value: /((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}/,
                            message: 'Некорректный телефон',
                        },
                        minLength: { value: 6, message: 'Минимум 6 символов' },
                        maxLength: { value: 20, message: 'Максимум 20 символов' },
                    })}
                    defaultValue={editingAddress.Phone || ''}
                    className="account-input"
                />
                {errors.Phone && <p className="account-error">{errors.Phone.message}</p>}
            </div>
        </div>

        <div className="account-actions">
            <button type="submit" className="account-button">
                Сохранить
            </button>
            <button type="button" onClick={handleCancel} className="account-button--ghost">
                Отмена
            </button>
        </div>
    </form>
);

export default AddressForm;
